import { Rule } from 'antd/lib/form';
import FormSelect from 'components/Select/FormSelect';
import { ISelectOption } from 'components/Select/types';
import React, { useEffect, useMemo } from 'react';
import { ICurrencies, IGetCurrencies } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getCurrencies } from 'backend/additionalInformation';
import { useTranslation } from 'react-i18next';

interface ICurrencySelect {
	setCurrencySymbol: (value: Nullable<string>) => void;
	setFetchedCurrencies: (value: ICurrencies[]) => void;
}

const CurrencySelect: React.FC<ICurrencySelect> = ({ setCurrencySymbol, setFetchedCurrencies }) => {
	const { t } = useTranslation('error');
	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectCurrency') }], [t]);
	const { response, loading, refetch, responseError } = useFetchData<IGetCurrencies, null>(getCurrencies);

	const mappedOptions = useMemo<ISelectOption[]>(() => {
		return response
			? response.data.currencies.map((el) => ({ id: el.isoCurrencySymbol, name: el.isoCurrencySymbol }))
			: [];
	}, [response]);

	useEffect(() => {
		response && setFetchedCurrencies(response.data.currencies);
	}, [response]);

	return (
		<FormSelect
			testId="CurrencySelect"
			name="selectedCurrencySymbol"
			label="currencyLabel"
			options={mappedOptions}
			fetchError={responseError}
			loading={loading}
			onRefetch={refetch}
			onChange={setCurrencySymbol}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(CurrencySelect);
